import { render, staticRenderFns } from "./EditJobMenu.vue?vue&type=template&id=454b6579"
import script from "./EditJobMenu.vue?vue&type=script&lang=js"
export * from "./EditJobMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports